import { ApolloProvider } from "@apollo/client";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { initializeAnalyticsFromEnv } from "./analytics";
import { createApolloClient } from "./apollo";
import "./index.css";
import { initBasecampSentry, reportBasecampError } from "./sentry";

initBasecampSentry();

function ErrorFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-primaryDarkBlue px-6 text-center text-white">
      <div className="max-w-sm space-y-3">
        <h1 className="font-oswald text-3xl font-medium uppercase tracking-wide">
          Something went wrong
        </h1>
        <p className="text-sm font-medium text-white/60">
          Please refresh the page or ask the front desk for help.
        </p>
      </div>
    </div>
  );
}

async function bootstrap() {
  initializeAnalyticsFromEnv();
  const client = await createApolloClient();
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog={false}>
        <ApolloProvider client={client}>
          <App />
        </ApolloProvider>
      </Sentry.ErrorBoundary>
    </React.StrictMode>,
  );
}

void bootstrap().catch((error) => {
  reportBasecampError(error, { feature: "bootstrap" });
  throw error;
});
